import { useState } from "react";
import { ItemInput } from "../@types";
import { showToast } from "../utils/toastUtils";

export default function useLineItems(initialItems: ItemInput[]) {
  const [items, setItems] = useState(initialItems);
  const reset = () => {
    setItems(initialItems);
  };
  const addItem = () => {
    if (!items.some((item) => item.name === "")) {
      setItems([
        ...items,
        {
          id: "",
          name: "",
          quantity: 0,
          rate: 0,
        },
      ]);
    }
  };

  const removeItem = (index: number) => {
    setItems(items.filter((_, itemIndex) => itemIndex !== index));
  };

  const updateCell = (
    index: number,
    field: keyof ItemInput,
    value: string | number,
  ) => {
    const newItems = [...items];
    newItems[index][field] = value;
    setItems(newItems);
  };

  const updateRow = (index: number, item: ItemInput, quantity?: number) => {
    const existingItem = items.find((i) => i.id === item.id);

    if (existingItem) {
      if (item.variantStatus === "has-no-variation") {
        showToast("Item already exists in the list.", "error");
        setItems(items.filter((_, itemIndex) => itemIndex !== index));
        return;
      }
    }
    // Update the row with the new item or variation
    const newItems = [...items];
    newItems[index] = item;

    if (quantity) {
      newItems[index].quantity = quantity;
    }

    setItems(newItems);
  };

  return { items, addItem, setItems, removeItem, updateCell, updateRow, reset };
}
